// @flow
/* eslint-disable import/no-mutable-exports */
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import createPalette from '@material-ui/core/styles/createPalette';
import responsiveFontSizes from '@material-ui/core/styles/responsiveFontSizes';
import mediaQuery from 'css-mediaquery';

import { INITIAL_BREAKPOINT } from './constants';
import type { ThemeOptions } from './types';

/* GatsbyStarterConfig: material-ui theme */
const palette = createPalette({});

let theme = createMuiTheme(
  ({
    palette,
    props: {
      MuiWithWidth: { initialWidth: INITIAL_BREAKPOINT },
      MuiUseMediaQuery: {
        ssrMatchMedia:
          typeof window === 'undefined'
            ? (query: string) => ({
                matches: mediaQuery.match(query, {
                  width: theme.breakpoints.values[INITIAL_BREAKPOINT],
                }),
              })
            : undefined,
      },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '.MuiListText-root': {
            margin: 0,
            position: 'relative',
          },
          '.MuiListText-padding': {
            paddingTop: 8,
            paddingBottom: 8,
          },
          '.MuiListText-ordered': {},
          '.MuiPreformatted-root': {
            maxWidth: '100%',
            overflowX: 'auto',
            fontSize: '1rem',
          },
        },
      },
      MuiFormControl: {
        root: {
          '&[hidden]': {
            display: 'none',
          },
        },
      },
    },
  }: ThemeOptions),
);

/* GatsbyStarterConfig: responsive font sizes */
theme = responsiveFontSizes(theme, {
  breakpoints: undefined,
  disableAlign: undefined,
  factor: undefined,
  variants: undefined,
});

export default theme;
